import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectLabelTemplates = (state: RootState) =>
  sortBy(state.labelTemplates.labelTemplates, 'no');

export const selectLabelTemplateErrors = (state: RootState) =>
  state.labelTemplates.errors;
